import React from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import {
  Avatar,
  // Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles,
} from "@material-ui/core";
import PeopleIcon from "@material-ui/icons/PeopleOutlined";

const useStyles = makeStyles((
  theme // prettier
) => ({
  root: {
    height: "100%",
    borderRadius: 25,
  },
  avatar: {
    backgroundColor: colors.green[600],
    height: 56,
    width: 56,
  },
  differenceIcon: {
    color: colors.green[900],
  },
  differenceValue: {
    color: colors.green[900],
    marginRight: theme.spacing(1),
  },
}));

const Enrollments = ({ className, data, ...rest }) => {
  const classes = useStyles();

  return (
    <Card className={clsx(classes.root, className)} {...rest}>
      <CardContent>
        <Grid container justify="space-between" spacing={3}>
          <Grid item>
            <Typography color="textSecondary" gutterBottom variant="h6">
              ENROLLMENTS
            </Typography>
            <Typography color="textPrimary" variant="h3">
              {data.length}
            </Typography>
          </Grid>
          <Grid item>
            <Avatar className={classes.avatar}>
              <PeopleIcon />
            </Avatar>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

Enrollments.propTypes = {
  className: PropTypes.string,
};

export default Enrollments;
